var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AbSection,{staticClass:"content-footnote-section",attrs:{"id":_vm.data.id,"spacing":_vm.data.spacing}},[_c(_setup.AbContainer,[_c(_setup.AbDescription,{domProps:{"innerHTML":_vm._s(_vm.data.text)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }